import { isOnline } from "./network";

// Each page is its own JS chunk, fetched the first time it opens. On the web,
// a page that hasn't opened yet in this tab can't load once the network
// drops, so logging a session offline crashed on /sessions/<local id>, and
// signing out offline crashed on /login. These loaders are shared with
// App.tsx's lazy routes, so prefetching one here means the later lazy()
// resolves from memory without the network.
export const loadDashboardPage = () =>
  import("@/pages/DashboardPage").then((m) => ({ default: m.DashboardPage }));
export const loadHistoryPage = () =>
  import("@/pages/HistoryPage").then((m) => ({ default: m.HistoryPage }));
export const loadSessionDetailPage = () =>
  import("@/pages/SessionDetailPage").then((m) => ({ default: m.SessionDetailPage }));
export const loadLoginPage = () => import("@/pages/LoginPage").then((m) => ({ default: m.LoginPage }));

const OFFLINE_PAGE_LOADERS = [loadDashboardPage, loadHistoryPage, loadSessionDetailPage, loadLoginPage];

let prefetched = false;

/**
 * Load the code for every page that works offline, so it's in memory before
 * the network drops. Does nothing while offline; call it again once back
 * online. Failures are ignored here: a real navigation reports them.
 *
 * @param loaders - The page loaders to run (defaults to the offline pages).
 */
export async function prefetchOfflinePages(loaders: Array<() => Promise<unknown>> = OFFLINE_PAGE_LOADERS): Promise<void> {
  if (prefetched || !(await isOnline())) return;
  const results = await Promise.allSettled(loaders.map((load) => load()));
  prefetched = results.every((result) => result.status === "fulfilled");
}

// Only for tests, so each one starts with nothing prefetched.
export function _resetPrefetchForTests(): void {
  prefetched = false;
}
